module.exports = __webpack_public_path__ + "img/logo-menu.aa417d33.png";